export default __webpack_public_path__ + "static/media/chaqueta-militar-mujer.86828509.png";